/* Emerald Heart — Theme JS */

document.addEventListener('DOMContentLoaded', () => {

  // Header scroll effect
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 20), { passive: true });
  }

  // Mobile nav
  const toggle = document.querySelector('.nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const closeBtn = document.querySelector('.mobile-nav-close');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => mobileNav.classList.add('open'));
    closeBtn?.addEventListener('click', () => mobileNav.classList.remove('open'));
    mobileNav.querySelectorAll('a').forEach(a =>
      a.addEventListener('click', () => mobileNav.classList.remove('open'))
    );
  }

  // FAQ accordion
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // Gift voucher amount selection
  document.querySelectorAll('.gift-amount-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.gift-amount-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
    });
  });

  // Quantity selectors
  document.querySelectorAll('.qty-row').forEach(row => {
    const input = row.querySelector('.qty-input');
    if (!input) return;
    row.querySelector('.qty-minus')?.addEventListener('click', () => {
      const v = parseInt(input.value); if (v > 1) input.value = v - 1;
    });
    row.querySelector('.qty-plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });
  });

  // Cart count
  refreshCartCount();

  // Add to cart
  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const orig = btn.textContent;
      btn.textContent = 'Adding…'; btn.disabled = true;
      try {
        const qty = form.querySelector('[name="quantity"]')?.value || 1;
        const id  = form.querySelector('[name="id"]')?.value;
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, quantity: parseInt(qty) })
        });
        if (res.ok) {
          btn.textContent = 'Added ✓';
          refreshCartCount();
          setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
        } else {
          btn.textContent = orig; btn.disabled = false;
        }
      } catch { btn.textContent = orig; btn.disabled = false; }
    });
  });

  // Cart item removal
  document.querySelectorAll('[data-remove-item]').forEach(btn => {
    btn.addEventListener('click', async () => {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.removeItem, quantity: 0 })
      });
      location.reload();
    });
  });
});

async function refreshCartCount() {
  try {
    const r = await fetch('/cart.js');
    const cart = await r.json();
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch {}
}
